import {
  MessageService,
  type MessageSvcSendMessageRequest,
} from '@kp/rest-api-javascript-sdk';

import { Language } from '../user';

export type Message = MessageSvcSendMessageRequest;

/**
 * Send a transactional e-mail rendered from a listmonk template
 *
 * @param message  The template name, its recipients and the template data
 */
export const sendMessage = (message: Message) =>
  MessageService.postSend({ body: message });

/**
 * Resolve the template language suffix from an i18next language tag, falling
 * back to English for unsupported languages.
 */
export const getTemplateLanguage = (language: string): Language => {
  const base = language.split('-')[0];
  return Object.values(Language).includes(base as Language)
    ? (base as Language)
    : Language.en;
};
